module.exports = __webpack_public_path__ + "img/can.be5030ca.webp";